import {Model} from "@/services/api";

export default class Inventory extends Model {
    static relations = {
        author: require("@/services/models/person").default,
        recipient: require("@/services/models/person").default,
        persons: require("@/services/models/person").default,
    };

    static route() {
        return 'correspondences';
    }
}
